import { types } from "../types/types";
import { fetchConToken } from '../helpers/fetch';
import { refreshUsuario } from './usuarios';

export const startLoadingClienteSaldos = ( id ) => {
    return async( dispatch ) => {
        try {
            const resp = await fetchConToken( `clientesaldo/listado/${ id }`, 'GET' );
            const body = await resp.json();
            console.log("Pasando por startLoadingClienteSaldos...");
            if( body.clienteSaldos ){
                dispatch( setClienteSaldos( body.clienteSaldos));
            }
        } catch (error) {
            console.log(error);
        }
    }
};

export const setClienteSaldos = ( clienteSaldos ) => ({
    type: types.clienteSaldosLoad,
    payload: clienteSaldos
});

export const startAddSaldoMonedero = ( usuarioId, monto, empresa ) => {
    return async( dispatch ) => {
        try {
            const saldoData = {
                empresa: empresa,
                monto: monto,
                metodoPago: 'Admin',
                updatedbyadmin: true
            }
            
            const respSaldo = await fetchConToken(`clientesaldo/nuevoclientesaldo/${usuarioId}`, saldoData, 'POST');
            const bodySaldo = await respSaldo.json();
            
            if (bodySaldo.ok) {
                const respUsuario = await fetchConToken(`usuarios/usuario`, {
                    usuario: usuarioId, 
                    empresa: empresa
                }, 'POST');
                const bodyUsuario = await respUsuario.json();
                if (bodyUsuario.usuario) {
                    dispatch(refreshUsuario(usuarioId, bodyUsuario.usuario));
                }
                
                dispatch(startLoadingClienteSaldos(usuarioId));
                
                return Promise.resolve(bodySaldo);
            } else {
                return Promise.reject(bodySaldo.msg);
            }
        } catch (error) {
            console.error('Error al añadir saldo al monedero:', error);
            return Promise.reject(error);
        }
    }
};